import * as ReactDeviceDetect from 'react-device-detect';
import { logAdminExternal } from './logging';


export type ErrorRequestObject = { error: { description: string } };

export interface fetchIpApiObject {
    ip: string
};

export async function fetchIpApiObject(): Promise<fetchIpApiObject> {
    return fetch('https://api.ipify.org?format=json')
        .then((response) => response.json())
        .catch((err: Error) => {
            logAdminExternal('Problem fetching my IP', err);
            return { ip: "error" }
        });
}

export interface GeolocationResponse {
    "country_code": string,
    "country_name": string,
    city: string,
    postal: string,
    latitude: number,
    longitude: number,
    IPv4: string,
    state: string
}

export async function fetchGeolocationApi(): Promise<GeolocationResponse> {
    return fetch('https://geolocation-db.com/json/')
        .then((response) => response.json())
        .catch((err: Error) => {
            logAdminExternal('Problem fetching my IP', err);
            return {
                "country_code": "error in function IpApiObject()",
                "country_name": `Message: ${err.message}`,
                city: "error",
                postal: "error",
                latitude: 0,
                longitude: 0,
                IPv4: "error",
                state: "error"
            }
        });
}

export interface DeviceData {
    'browserName': string,
    'deviceType': string,
    'getUA': string,
    'mobileModel': string,
    'mobileVendor': string,
    'osName': string,
}

export const deviceDataDefaultObj = {
    'browserName': "error",
    'deviceType': "error",
    'getUA': "error",
    'mobileModel': "error",
    'mobileVendor': "error",
    'osName': "error",
}

export function getDeviceData(): DeviceData {
    // Use ReactDeviceDetect library to get device data.
    return Object.keys(ReactDeviceDetect).reduce<DeviceData>((prev, cur) => {
        // Filter only useful keys
        const usefulKeys = [
            'browserName',
            'deviceType',
            'getUA',
            'mobileModel',
            'mobileVendor',
            'osName',
        ];
        const thisValue = (ReactDeviceDetect as unknown as Record<string, string>)[cur];
        if (usefulKeys.includes(cur) && typeof thisValue === "string") {
            const returnObj = { ...prev };
            returnObj[cur as keyof DeviceData] = thisValue || "error";
            return returnObj;
        }
        return prev;
    }, {} as DeviceData);
}